import { trpc } from "@/lib/trpc";
import { definirOrgDoVerComo, emVerComo } from "@/lib/ver-como";

/** Troca a organização ativa (`organization.switch`) e invalida todo o cache do React Query —
 *  sidebar, nav e qualquer query escopada implicitamente à organização ativa passam a refletir
 *  a nova organização na próxima leitura. */
export function useSwitchOrganization() {
  const utils = trpc.useUtils();
  const mutation = trpc.organization.switch.useMutation({
    onSuccess: () => utils.invalidate(),
  });

  return {
    // No "ver como" a troca vale só pra aba: a organização ativa da pessoa não é tocada.
    switchTo: async (organizationId: string) => {
      if (!emVerComo()) return mutation.mutateAsync({ organizationId });
      definirOrgDoVerComo(organizationId);
      await utils.invalidate();
      return { success: true };
    },
    isSwitching: mutation.isPending,
  };
}
